import { Link, useCanGoBack, useRouter } from '@tanstack/react-router'

import { useT } from '@/lib/i18n/translate'

interface BackLinkProps {
  /** Where to go when nothing in this tab came before: a deep link, a fresh tab. */
  to: '/$restaurantSlug/$branchSlug/manage/queue' | '/$restaurantSlug/$branchSlug/manage/sessions'
  params: { restaurantSlug: string; branchSlug: string }
}

/**
 * Back to the page the staff came from — the queue, a search, statistics, a session, the
 * create-order page — so their work is where they left it. Only a cold start falls back to `to`.
 */
export function BackLink({ to, params }: BackLinkProps) {
  const t = useT()
  const router = useRouter()
  const canGoBack = useCanGoBack()
  return (
    <Link
      to={to}
      params={params}
      onClick={(event) => {
        if (!canGoBack) return
        event.preventDefault()
        router.history.back()
      }}
      className="text-accent-ink self-start font-medium print:hidden"
    >
      {t('common.back')}
    </Link>
  )
}
